export default __webpack_public_path__ + "fac5d53fe89491ce906138e92c8c01e9.svg";